import { UseGqlMutationCallbacks } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import { CreateMagicLinkLoginMutation, useCreateMagicLinkLoginMutation } from './createMagicLinkLogin_gen'

type CreateMagicLinkLoginProps = { email: string; redirectTo?: string }

type UseCreateMagicLinkLoginMutationOptions = UseGqlMutationCallbacks<
  CreateMagicLinkLoginMutation,
  CreateMagicLinkLoginProps
>

export const useCreateMagicLinkLogin = (mutationOptions?: UseCreateMagicLinkLoginMutationOptions) => {
  const intl = useIntl()

  const _mutationOptions = useMutationNotifier(
    {
      onMutate: intl.formatMessage({ id: 'auth.login.requesting_code' }),
      onSuccess: false,
    },
    mutationOptions
  )

  const { mutateAsync: createMagicLinkLogin } = useCreateMagicLinkLoginMutation()
  return useMutation(['createMagicLinkLogin'], (input) => createMagicLinkLogin({ input }), _mutationOptions)
}
